import { getUrlParameter } from '@/utils/assist'
export default ({app}) => {
  let urlObj = getUrlParameter(), isChoose = false, pathCount = 0;
  if (typeof urlObj === 'object' && urlObj.hasOwnProperty('platformKey')&&urlObj.hasOwnProperty('orderId')) {
    isChoose = true;
  }
  app.router.beforeEach((to, form, next) => {
    console.log(form,'form')
    let { name } = to,
          isPageChoose = isChoose || app.store.state.booking.user.isChoose;
    pathCount++;

    if(form.name=='customer'){

      if(app.store.state.booking.user.oldAddressData){
        let oldAddress = app.store.state.booking.user.oldAddressData.address
        let  oldLongitude= app.store.state.booking.user.oldAddressData.longitude
        let  oldLatitude= app.store.state.booking.user.oldAddressData.latitude
        let  address = app.store.state.booking.user.consigneeAddress
        let  longitude= app.store.state.booking.user.longitude
        let  latitude= app.store.state.booking.user.latitude
        if(oldAddress!=address&&oldLongitude==longitude&&oldLatitude==latitude){
          next(false);
          return false
        }
        
      }
     
    }
    if (isPageChoose) {
      if (name === 'choose' || (pathCount === 1&&name !=='customer')) {
        next({name: 'customer'});
      } else {
        next();
      }
    } else if (name !== 'choose') {
      next({name: 'choose'});
    } else {
      next();
    }
	});
  app.router.afterEach((to, form) => {
  })
}



// WEBPACK FOOTER //
// ./plugins/router.js